<div>
  <section>
    <header>
      <label class="h5"><strong>{{tarjetaPasos.titulo}}</strong></label>
    </header>
    <footer>
      <p class="card-text mb-2 text-muted h6" [innerHTML]="tarjetaPasos.descripcion"></p>
    </footer>
  </section>
</div>
